export default "__VITE_ASSET__b23c4470__"